import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { MenuBuilder } from "../../components/menu/MenuBuilder";

const ProcurmentPage = ({}) => {
  const navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem("user"));

  let menu = [
    {
      auth: "PurchaseRequisition",
      name: "Material and Services Request (MSR)",
      path: "/procurment/transaction/Material-and-Services-Request",
    },
    {
      auth: "Allocation",
      name: "Allocation",
      path: "/procurment/transaction/Allocation",
    },

    {
      auth: "PriceComparison",
      name: "Price Comparison",
      path: "/procurment/transaksi/price-comparison",
    },
    {
      auth: "OrderWarehouse",
      name: "Purchase order",
      path: "/procurment/transaksi/purchase-order",
    },
  ];
  let Report = [
    {
      auth: "MonitoringPurchaseRequisition",
      name: "Monitoring Material and Services Request (MSR)",
      path: "/procurment/report/Material-and-Services-Request",
    },
    {
      auth: "MonitoringPriceComparison",
      name: "Monitoring Price Comparison",
      path: "/procurment/report/price-comparison",
    },
    {
      auth: "MonitoringPurchraseOrder",
      name: "Monitoring Purchase Order",
      path: "/procurment/report/purchase-order",
    },
    // {
    //     auth: "MonitoringPurchaseRequisition",
    //     name: "Laporan Material and Services Request (MSR)",
    //     path: "/procurment/laporan/Material-and-Services-Request"
    // },
    {
      auth: "LaporanPurchaseOrder",
      name: "Laporan Purchase Order",
      path: "/procurment/laporan/purchase-order",
    },

    // {
    //     auth: "PurchaseRequisition",
    //     name: "Price Comparison",
    //     path: "/procurment/report/price-comparison"
    // },
  ];
  const [listMenu, setListMenu] = useState(menu);
  const [listReport, setListReport] = useState(Report);

  const filterMenu = (event) => {
    const filtered = menu.filter(({ name }) =>
      name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setListMenu(filtered);
  };
  const filterReport = (event) => {
    const filtered = Report.filter(({ name }) =>
      name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setListReport(filtered);
  };
  return (
    <div className="md:ml-64">
      <div className="w-full flex flex-col items-center">
        <div className="w-full px-4 my-4 ">
          <MenuBuilder
            name="Transaction"
            menuController={filterMenu}
            listMenu={listMenu}
          />
          <hr className={"border border-main-100 my-6"} />
          <MenuBuilder
            name="Report"
            menuController={filterReport}
            listMenu={listReport}
          />
        </div>
      </div>
    </div>
  );
};

export default ProcurmentPage;
